import React, { useState } from "react";
import "./MeetOurTeam.css";

// Import images
import neelamImage from "./image/neelam_pic.png";
import hanumatImage from "./image/hanumat1.png";
import lavkushImage from "./image/lavkush.png";
import rajuImage from "./image/raju.png";
import nipunImage from "./image/nipun.jpg";
import srinivasImage from "./image/srinivas.png";
import raghusirImage from "./image/raghusir.jpeg";
import saikatImage from "./image/saikatsir.jpeg";
import mrsirImage from "./image/mrsir.jpeg";
import harpalImage from "./image/harpal.png";
import tulsiImage from "./image/tulsi_pic.png";

import Footer from "./Footer";
import SocialSidebar from "../components/SocialSideBar";

// Members are listed in the exact order of `names`; Mentors & Guides = everyone with that role, in data order.
const CATEGORIES = [
  { id: "jee-neet", label: "JEE/NEET Faculties", tagline: "Expert guidance for JEE & NEET aspirants", names: ["Hanumat Lal Vishwakarma", "Nipun", "Tulsi Sharma"] },
  { id: "class-11-12", label: "Class 11-12th Teachers", tagline: "Strong concepts for Boards and competitive exams", names: ["Nipun", "Tulsi Sharma", "Raju Vishvas"] },
  { id: "class-6-10", label: "Class 6-10th Faculties", tagline: "Building the right foundation from the start", names: ["Raju Vishvas", "Lavkush Kumar Singh"] },
  { id: "mentors", label: "Mentors & Guides", tagline: "Mentorship from alumni who have walked the path" },
  { id: "founding", label: "Founding Members", tagline: "The people behind PrrepX Pathshala", names: ["Hanumat Lal Vishwakarma", "Neelam Vishvakarma", "Lavkush Kumar Singh", "Raju Vishvas", "Harpal Singh"] },
];

const teamData = [
  { name: "Hanumat Lal Vishwakarma", role: "Founder & Managing Director (MD)", currentPosition: "SWE at Rakuten Tokyo, Japan", education: "M.Tech(CSE) from IIT Ropar, B.Tech(CSE) from NIT Manipur", crackedExams: "Cracked Exams: GATE 2020(AIR 1343), GATE 2019, IIT-JEE(Mains), UPSEEE, BHU UET, MMMUT Qualified", teaching: "JEE Mains & Adv Mathematics", image: hanumatImage, tag: "IIT Ropar" },
  { name: "Nipun", role: "Associate Physics Faculty", currentPosition: "2 Years of Teaching Experiences.", education: "B.Tech from IIT Bombay", crackedExams: "JEE Adv. (AIR 5060), JEE Mains (AIR 7500) ,IIST 2012", teaching: "JEE/NEET, Class 11-12 Physics", image: nipunImage, tag: "IIT Bombay" },
  { name: "Tulsi Sharma", role: "Associate Chemistry Faculty", currentPosition: "2 Years of Teaching Experiences.", education: "M.Sc. from IIT Delhi, B.Sc. from DU", crackedExams: "IIT JAM Qualified (AIR 186)", teaching: "JEE/NEET, Class 11-12 Chemistry", image: tulsiImage, tag: "IIT Delhi" },
  { name: "Harpal Singh", role: "Co-founder & Marketing Head", currentPosition: "Ex-Self Employed Business", education: "M.Tech(CSE) from IIT Ropar, B.Tech (CSE) from Punjab University", crackedExams: "GATE-2020, IIT-JEE(Mains)-2015", image: harpalImage, tag: "IIT Ropar" },

   { name: "Neelam Vishvakarma", role: "Co-founder & Technical Head", currentPosition: "SWE at Rakuten Tokyo, Japan", education: "MCA (IT) from IMS GHZ", crackedExams: "Cracked Exams: IIT-JAM 2013, NIMCET 2014, UPTU 2015", responsibilities: "Technical Management & Daily Operations.", image: neelamImage, tag: "IMS GHZ" },
  { name: "Lavkush Kumar Singh", role: "Co-founder & Director", currentPosition: "Ex-Self Employed Business", education: "B.Tech (EE) from NIT Manipur", crackedExams: "IIT-JEE(Mains)-2015, UPSEEE-2015", teaching: "Class 6-10 Science", image: lavkushImage, tag: "NIT Manipur" },
  { name: "Raju Vishvas", role: "Co-Founder & Director", currentPosition: "2.5+ years teaching experience to IIT-JEE students", education: "B.Tech (CE) from NIT Manipur", crackedExams: "GATE-2020 (AIR 2884), GATE-2019, IIT-JEE(Mains)-2015", teaching: "Class 6-12 Mathematics", image: rajuImage, tag: "NIT Manipur" },
  //{ name: "Raushan Kumar", role: "Associate Physics Faculty", currentPosition: "", education: "M.Tech (ME) from IIT Patna", crackedExams: "GATE 2024, JEE Main 2016, WBJEE 2016, BCECE 2016", teaching: "JEE/NEET, Class 11-12 Physics", image: raushanImage, tag: "IIT Patna" },
  
  { name: "Dr. Raghuram Gujjarappa", role: "Mentor and Guide", education: "Postdoctoral Fellow at Missouri S&T, USA + M.Sc & Ph.D (Chemistry) from NIT Manipur", crackedExams: "GATE 2015 (AIR 450), GATE 2017, GATE 2019, GATE 2020, KSET 2014", image: raghusirImage, tag: "Missouri S&T, USA" },
  { name: "Dr. Saikat Mishra", role: "Mentor and Guide", education: "Postdoctoral Fellow at Southern Methodist University, USA + Former Postdoctoral Fellow at Tulane University, USA +  Ph.D (Chemistry) from NIT Durgapur.", crackedExams: "GATE 2014 (AIR 299)", image: saikatImage, tag: "SMU, USA" },
  { name: "Dr. Nagaraju Vodnala", role: "Mentor and Guide", education: "Postdoctoral scientist at SMU (Southern Methodist University), USA + M.Sc, Ph.D (Chemistry, NIT Manipur), ", crackedExams: "CSIR-NET 2014 Jun (AIR 34), CSIR-NET 2014 Dec (AIR 45), APSET 2014", image: mrsirImage, tag: "SMU, USA" },
  { name: "Srinivas P", role: "Mentor and Guide", education: "M.Tech(CSE) from IIT Ropar", crackedExams: "GATE CSE(98.86 percentile), BITS, VIT, SRM, PES, KCET", image: srinivasImage, tag: "IIT Ropar" },
  
];
const getCategoryMembers = (cat) =>
  cat.names
    ? cat.names.map((n) => teamData.find((m) => m.name === n)).filter(Boolean)
    : teamData.filter((m) => m.role === "Mentor and Guide");

const getAlumniTag = (member) => {
  if (member.tag) return member.tag;
  const edu = member.education || "";
  const iitMatch = edu.match(/IIT\s*([A-Za-z]+)/);
  if (iitMatch) return `IIT ${iitMatch[1]}`;
  const nitMatch = edu.match(/NIT\s*([A-Za-z]+)/);
  if (nitMatch) return `NIT ${nitMatch[1]}`;
  const iitbhuMatch = edu.match(/IIT-BHU\s*([A-Za-z]+)/);
  if (iitbhuMatch) return `IIT-BHU ${iitbhuMatch[1]}`;
  if (edu.includes("MBBS")) return "Medical Alumni";
  if (edu.includes("MCA")) return "IMS Alumni";
  return "Expert Mentor";
};

const TeamCard = ({ member }) => {
  const alumniTag = getAlumniTag(member);
  return (
    <div className="team-grid-card">
      <div className="alumni-badge">{alumniTag}</div>
      <div className="profile-frame">
        {member.image ? (
          <img src={member.image} alt={member.name} className="img-fluid" />
        ) : (
          <div className="img-placeholder"></div>
        )}
      </div>
      <div className="card-info">
        <h3 className="m-name">{member.name}</h3>
        <p className="m-role">{member.role}</p>
        <div className="m-details">
          {member.teaching && <p className="m-text teaching-row-pulse">📘 {member.teaching}</p>}
          {member.responsibilities && <p className="m-text">🎯 {member.responsibilities}</p>}
          {(member.education || member.currentPosition) && (
            <p className="m-text">
              {member.currentPosition && <>💼 {member.currentPosition}</>} 🎓{" "}
              {member.education}
            </p>
          )}
          {member.crackedExams && <p className="m-text-italic">🏆 {member.crackedExams}</p>}
        </div>
      </div>
    </div>
  );
};

const FoundingCard = ({ member }) => {
  const position = member.foundingPosition !== undefined ? member.foundingPosition : member.currentPosition;
  const exams = (member.crackedExams || "").replace(/^Cracked Exams:\s*/i, "");
  return (
    <div className="founder-card">
      <div className="alumni-badge">{getAlumniTag(member)}</div>
      <div className="founder-photo">
        {member.image ? <img src={member.image} alt={member.name} /> : <div className="img-placeholder"></div>}
      </div>
      <h3 className="founder-name">{member.name}</h3>
      <p className="founder-role">{member.role}</p>
      <ul className="founder-facts">
        {member.education && <li><span>🎓</span>{member.education}</li>}
        {position && <li><span>💼</span>{position}</li>}
        {exams && <li><span>🏆</span>{exams}</li>}
      </ul>
    </div>
  );
};

const CategoryBlock = ({ cat, members }) => (
  <section className={`team-block theme-${cat.id}`}>
    <div className="team-block-inner">
      <h2 className="cat-title">{cat.label}</h2>
      <p className="cat-tagline">{cat.tagline}</p>
      {cat.id === "founding" ? (
        <div className="team-grid founding-grid">
          {members.map((member) => (
            <FoundingCard key={member.name} member={member} />
          ))}
        </div>
      ) : (
        <TeamGrid teamMembers={members} />
      )}
    </div>
  </section>
);

const TeamGrid = ({ teamMembers }) => (
  <div className="team-grid">
    {teamMembers.map((member, index) => (
      <TeamCard key={index} member={member} />
    ))}
  </div>
);

const MeetOurTeam = () => {
  const [activeCategory, setActiveCategory] = useState("all");

  const activeCat = CATEGORIES.find((c) => c.id === activeCategory);
  const visibleCats = activeCat ? [activeCat] : CATEGORIES;

  return (
    <div className="team-page-wrapper">
      <SocialSidebar />
      <header className="team-hero">
        <div className="team-hero-inner">
          <h1 className="main-title">Meet Our Team</h1>
          <div className="title-line"></div>
          <p className="intro-text">
            100% of our faculties and mentors are <strong>IIT, NIT & Medical alumni only</strong>, so you get real guidance from people who have lived the journey students aspire to take.
            With real exam experiences and deep subject expertise, they’re not just teachers—they’re mentors who truly understand what it takes to succeed.
          </p>
        </div>
      </header>

      <div className="team-filter-strip">
        <div className="team-filter-bar" role="tablist" aria-label="Filter team by category">
          {[{ id: "all", label: "All" }, ...CATEGORIES].map((cat) => (
            <button
              key={cat.id}
              type="button"
              role="tab"
              aria-selected={activeCategory === cat.id}
              className={`team-filter-btn${activeCategory === cat.id ? " active" : ""}`}
              onClick={() => setActiveCategory(cat.id)}
            >
              {cat.label}
            </button>
          ))}
        </div>
      </div>

      {visibleCats.map((cat) => {
        const members = getCategoryMembers(cat);
        return members.length ? <CategoryBlock key={cat.id} cat={cat} members={members} /> : null;
      })}

      <Footer />
    </div>
  );
};

export default MeetOurTeam;
